import { sortOptions } from "@/utils/filter";

interface SortBarProps {
  sort: string;
  onSortChange: (value: string) => void;
  total: number;
}

export default function SortBar({ sort, onSortChange, total }: SortBarProps) {
  return (
    <div className="flex flex-col gap-3 rounded-lg border border-background-800 bg-background-900 p-3 sm:flex-row sm:items-center sm:justify-between md:p-4">
      <p className="text-sm text-foreground-400">
        共找到 <span className="font-label font-bold text-primary-400">{total}</span> 个视频
      </p>
      <div className="flex flex-wrap items-center gap-1.5">
        {sortOptions.map((opt) => {
          const on = sort === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onSortChange(opt.value)}
              className={`flex items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-semibold transition-colors ${
                on
                  ? "bg-primary-500 text-background-950"
                  : "bg-background-800 text-foreground-400 hover:text-foreground-100"
              }`}
            >
              <i className={`${opt.icon} text-sm`} />
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}